import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { authLogout } from '../store/auth/actions';

export default function RequireAuthentication(Component) {
  class AuthenticatedComponent extends React.Component {
    static propTypes = {
      isAuthenticated: PropTypes.bool.isRequired,
      logout: PropTypes.func.isRequired,
    };

    UNSAFE_componentWillMount() {
      if (
        this.props.currentLocation !== '/campaigns/' &&
        this.props.currentLocation !== '/campaigns'
      ) {
        localStorage.setItem('redirectTo', this.props.currentLocation);
      }

      this.checkAuth(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      this.checkAuth(nextProps);
    }

    checkAuth = ({ isAuthenticated, currentLocation, logout }) => {
      if (!isAuthenticated) {
        if (
          this.props.currentLocation !== '/campaigns/' &&
          this.props.currentLocation !== '/campaigns'
        ) {
          localStorage.setItem('redirectTo', currentLocation);
        }
        logout();
      }
    };

    render() {
      const { isAuthenticated } = this.props;
      return <div>{isAuthenticated === true ? <Component {...this.props} /> : null}</div>;
    }
  }

  const mapStateToProps = state => ({
    currentLocation: get(state, 'router.location.pathname'),
    isAuthenticated: !!get(state, 'auth.user.token', false),
  });

  const mapDispatchToProps = dispatch => ({
    logout: () => dispatch(authLogout()),
  });

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(AuthenticatedComponent);
}
